// Configure your import map in config/importmap.rb. Read more: https://github.com/rails/importmap-rails

//Sign in module
document.addEventListener("DOMContentLoaded", function () {
  const modal = document.getElementById("login-modal");
  const openModalButtons = document.querySelectorAll("#open-modal");

  openModalButtons.forEach((button) => {
    button.addEventListener("click", function () {
      modal.style.display = "block";
    });
  });
});

if (document.querySelector('[data-page="marketing"]')) {
  import('./marketing.js');
}

import mount from "./mount";
import DashboardRouter from "./routers/dashboard.tsx";
import SignIn from "./components/auth/sign_in.tsx";
import ForgotPassword from "./components/auth/forgot_password.tsx";
import ResetPassword from "./components/auth/reset_password.tsx";
import EditAccount from "./components/auth/edit_account.tsx";

// Add all mounted components here.
// mount will scan the DOM for valid html mountpoints, and mount the specified component in place.
mount({
  DashboardRouter,
  SignIn,
  ForgotPassword,
  ResetPassword,
  EditAccount,
});
